import EditAction from './components/EditAction'

import { Provider } from '../../../../../graphql'

function render( provider: Provider ) {
	return ( <EditAction provider={provider} /> )
}

export default {
	actions: [ {
		isPrimary: true,
		render,
	} ],
	name: 'Actions',
}
